// --- External Libraries
import moment from 'moment';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const id = {
    field: 'id',
    headerName: 'ID',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'rights',
    },
};

export const rightId = {
    field: 'rightId',
    headerName: 'Right ID',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightId',
        page: 'rights',
    },
};

export const rightTitle = {
    field: 'rightTitle',
    headerName: 'Title',
    width: 350,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightTitle',
        page: 'rights',
    },
};

export const rightTemplate = {
    field: 'rightTemplate',
    headerName: 'Template',
    width: 250,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const rightMedia = {
    field: 'rightMedia',
    headerName: 'Media',
    tooltipField: 'rightMedia',
    width: 350,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightMedia',
        page: 'rights',
    },
};

export const rightTerritory = {
    field: 'rightTerritory',
    headerName: 'Territory',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightTerritory',
        page: 'rights',
    },
};

export const rightLanguage = {
    field: 'rightLanguage',
    headerName: 'Language',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightLanguage',
        page: 'rights',
    },
};

export const actualTermStart = {
    field: 'actualTermStart',
    headerName: 'Start',
    width: 125,
    valueFormatter: ({ value }) => value ? moment(moment(value).utc().format('YYYY-MM-DD[T]HH:mm:ss')).format('MM/DD/YYYY') : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'actualTermStart',
        page: 'rights',
    },
};

export const actualTermEnd = {
    field: 'actualTermEnd',
    headerName: 'End',
    width: 125,
    valueFormatter: ({ value }) => value ? moment(moment(value).utc().format('YYYY-MM-DD[T]HH:mm:ss')).format('MM/DD/YYYY') : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'actualTermEnd',
        page: 'rights',
    },
};

export const startDateStatus = {
    field: 'startDateStatus',
    headerName: 'Start Status',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'startDateStatus',
        page: 'rights',
    },
};

export const endDateStatus = {
    field: 'endDateStatus',
    headerName: 'End Status',
    width: 125,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'endDateStatus',
        page: 'rights',
    },
};

export const dealId = {
    field: 'dealId',
    headerName: 'Deal ID',
    width: 125,
    valueFormatter: ({ value }) => value !== -1 ? value : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'dealId',
        page: 'rights',
    },
};

export const catalogId = {
    field: 'catalogId',
    headerName: 'Catalog ID',
    width: 125,
    valueFormatter: ({ value }) => value !== -1 ? value : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'catalogId',
        page: 'rights',
    },
};

export const dealRecentlyAssociated = {
    field: 'associationEntity.dealId',
    headerName: 'Deal Recently Associated',
    width: 200,
    valueFormatter: ({ value }) => value !== -1 ? value : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'associationEntity.dealId',
        page: 'rights',
    },
};

export const catalogRecentlyAssociated = {
    field: 'associationEntity.catalogId',
    headerName: 'Catalog Recently Associated',
    width: 200,
    valueFormatter: ({ value }) => value !== -1 ? value : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'associationEntity.catalogId',
        page: 'rights',
    },
};

export const associate = (
    onOpenAssociateDrawer,
) => ({
    headerName: '',
    valueGetter: () => {
        return 'ASSOCIATE';
    },
    tooltipField: '',
    cellRenderer: ClickableCellRenderer(onOpenAssociateDrawer, 'fa-wrench'),
    width: 125,
});

export const rightCreated = {
    field: 'rightCreated',
    headerName: 'Created',
    width: 125,
    valueFormatter: ({ value }) => value ? moment(value).format('MM/DD/YYYY') : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightCreated',
        page: 'rights',
    },
};

